import HTTPClient from '../..'

export const deleteMonitorByIdAPI = async (id) => {
  const data = await HTTPClient.delete(`monitor/${id}`)

  return data
}
